import { render, staticRenderFns } from "./ImageManager.vue?vue&type=template&id=b6b9afa6&scoped=true"
import script from "./ImageManager.vue?vue&type=script&lang=js"
export * from "./ImageManager.vue?vue&type=script&lang=js"
import style0 from "./ImageManager.vue?vue&type=style&index=0&id=b6b9afa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b9afa6",
  null
  
)

export default component.exports